<template lang="pug">
  li
    span 0{{ index + 1 }}
    h3
      router-link(:to="url") {{ title }}
</template>

<script>

export default {
  props: ['index', 'title', 'url']
}

</script>

<style lang="stylus" scope>

li
  cursor pointer
  display: flex
  align-items baseline
  justify-content: flex-start

  @media screen and (max-height: 850px)

    padding  20px inherit

  &:hover

    h3

      opacity 0.5
      letter-spacing 3px
      transform translateX(-3px)
  span

    font-weight 400
    font-size: 8px;
    vertical-align middle
    letter-spacing: 2px;
    text-align center
    box-sizing border-box
    border 1px solid transparent
    margin-right 15px
    position relative
    transition all 1s $ease

    @media $mq_m
      margin-right 25px
      font-size: 11px;
      font-weight 600

    @media $mq_l
      margin-right 35px
      font-size: 14px;

  h3
    vertical-align middle
    display inline-block
    transition all 1s $ease
    font-size: 20px
    line-height: 1em

    @media $mq_m
      font-size: 30px

    @media $mq_l
      font-size: 40px

    @media screen and (max-height: 850px)

      font-size 30px

    @media screen and (max-height: 770px)

      font-size 20px

    a
      text-decoration none
      color $black

</style>
